export default __webpack_public_path__ + "static/media/bg.3f7260ed.jpg";